<template>
  <header class="header">
    <div class="header__inner">
      <h1 class="header__column">
        <a 
          href="#" 
          class="header__logo"
        >
          UILab
        </a>
      </h1>
      <nav class="header__column">
        <!-- [s] 210304 | 각 앵커마다 href 추가 및 @click 이벤트 추가 -->
        <ul class="gnb">
          <li class="gnb__item">
            <a 
              v-scroll-to="{
                el: '#services',
                duration: 500,
                lazy: false,
                easing: 'linear',
                offset: -100,
                force: true,
                cancelable: true,
              }"
              class="gnb__anchor"
              href="#"
            >
              기술
            </a>
          </li>
          <li class="gnb__item">
            <a 
              v-scroll-to="{
                el: '#about',
                duration: 500,
                lazy: false,
                easing: 'linear',
                offset: -100,
                force: true,
                cancelable: true,
              }"
              class="gnb__anchor"
              href="#"
            >
              특장점
            </a>
          </li>
          <li class="gnb__item">
            <a 
              v-scroll-to="{
                el: '#projects',
                duration: 500,
                lazy: false,
                easing: 'linear',
                offset: -100,
                force: true,
                cancelable: true,
              }"
              class="gnb__anchor"
              href="#"
            >
              경험
            </a>
          </li>
          <li class="gnb__item">
            <a 
              v-scroll-to="{
                el: '#faq',
                duration: 500,
                lazy: false,
                easing: 'linear',
                offset: -100,
                force: true,
                cancelable: true,
              }"
              class="gnb__anchor"
              href="#"
            >
              고객문의
            </a>
          </li>
          <li class="gnb__item">
            <a
              v-scroll-to="{
                el: '#recruit',
                duration: 500,
                lazy: false,
                easing: 'linear',
                offset: -100,
                force: true,
                cancelable: true,
              }"
              class="gnb__anchor"
              href="#"
            >
              채용
            </a>
          </li>
        </ul>
        <!-- [e] 210304 | 각 앵커마다 href값 변경 및 @click 이벤트 추가 -->
      </nav>
      <div class="header__column header__column--button">
        <button
          type="button"
          class="button button--primary"
          @click="openModal('request')"
        >
          프로젝트 의뢰하기
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      scrollPosition: 10
    }
  },
  methods: {
    openModal(target) {
      if (target === 'request') {
        this.$gtag.query('event', 'Request', {
          app_name: 'UILab Homepage',
          screen_name: 'Request Popup',
        })
      }
      this.$store.commit('modalOpen', target)
    },
  }
}
</script>

<style lang="scss" scoped>
.header{
  $self:&;
  width:100%;
  height:100px;
  background-color: #fff;
  position:fixed;
  z-index:99999;
  //스크롤 했을 때, 스타일 변화
  &[data-state="sticky"]{
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.04);
  }
  &__inner{
    width:1000px;
    height:inherit;
    margin:0 auto;
    position:relative;
    display:flex;
    align-items: center;
    justify-content: space-between;    
  }
  &__column{
    &--button{
      width:138px;
      height:40px;
    }
  }
  &__logo{
    font-size:32px;
    font-weight: bold;
    color:#111111;
    display:block;
    padding:20px 0;    
  }
}

.gnb{
  $self:&;
  width:100%;
  &__item{
    display:inline-block;
    &:not(:first-child){
      margin-left:10px;
    }
  }
  &__anchor{
    font-size:16px;
    color:#111;    
    font-weight: 500;
    padding:25px 20px;
    display:block;
  }
}
</style>